import React from 'react';
import { Link } from 'react-router-dom';

import ServiceCard from '../components/ServiceCard';


const Home = ({ formSubmitted, setFormSubmitted }) => {
  const services = [
    {
      title: "Solar Power Systems",
      description: "Installation of solar power systems for residential and commercial properties."
    },
  
    
    {
      title: "ELEVATOR AND ESCALATOR SYSTEMS",
      description: "Installation, modernization, and maintenance of lift systems with advanced control systems."
    },
    {
      title: "INDUSTRIAL AUTOMATION",
      description: "Custom automation systems with PLC programming and SCADA development."
    },
    
    {
      title: "SMART PARKING TOWERS",
      description: "Automated vertical parking systems that maximize space utilization."
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Smart Solutions for Electromechanical Systems</h1>
            <p>Innovative, reliable, and efficient solutions that enhance safety, convenience, and sustainability</p>
            <Link to="/activity" className="cta-button">Explore Our Services</Link>
          </div>
        </div>
      </section>

      {/* About Preview */}
      <section className="section about-preview">
        <div className="container">
          <h2 className="section-title">About TAQNYA FZCO</h2>
          <div className="about-content">
            <p style={{ textAlign: 'center', fontSize: '18px', color: '#666', marginBottom: '40px', maxWidth: '800px', margin: '0 auto 40px' }}>
              TAQNYA FZCO is a leading provider of electromechanical systems and smart solutions based in the United Arab Emirates. 
              With a steadfast commitment to innovation, reliability, and efficiency, we empower our clients with cutting-edge solutions.
            </p>
            
            <div className="mission-vision">
              <div className="mission">
                <h3>Our Mission</h3>
                <p>To deliver innovative, reliable, and efficient electromechanical solutions that enhance safety, convenience, and sustainability for our clients.</p>
              </div>
              <div className="vision">
                <h3>Our Vision</h3>
                <p>To be the preferred partner in smart electromechanical solutions across the region, distinguished by our excellence in technological innovation and service delivery.</p>
              </div>
            </div>
            <Link to="/about" className="learn-more">Learn More About Us →</Link>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Our Core Services</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <ServiceCard key={index} service={service} />
            ))}
          </div>
          <div style={{ textAlign: 'center' }}>
            <Link to="/activity" className="view-all">View All Services →</Link>
          </div>
        </div>
      </section>

      </div>
    );
            
  }


export default Home;